/** Shared permission descriptions for OAuth consent and MCP connection management. */
export const MCP_PERMISSION_OPTIONS: ReadonlyArray<{ scope: string; label: string; isNew?: boolean }> = [
	{ scope: 'keywords:read', label: 'Use KW Suggestions, Product Explorer, Tag Generator and Workbench; read trends and KW Lists' },
	{ scope: 'keywords:lists:write', label: 'Create and replace KW Lists' },
	{ scope: 'keywords:lists:delete', label: 'Permanently delete KW Lists' },
	{ scope: 'keywords:live', label: 'Run KW Search and KW Hunter (start, monitor and stop searches)' },
	{ scope: 'design:ai:read', label: 'Read your AI Design Editor job status and results' },
	{ scope: 'design:ai:write', label: 'Upload, generate and edit AI images (spends account API tokens)' },
	{ scope: 'research:ai', label: 'Generate AI Research niches, prompts, quotes and puns (uses provider quota)' },
	{ scope: 'listing:ai:generate', label: 'Generate AI listing drafts using your saved settings (spends Flying API tokens)', isNew: true },
	{ scope: 'advertising:read', label: 'Read Ad Lists and evaluate Rank Positioning and Ad Potential' },
	{ scope: 'advertising:live', label: 'Run product-specific Ad Suggestions searches' },
	{ scope: 'advertising:write', label: 'Create and replace Ad Lists' },
	{ scope: 'advertising:delete', label: 'Permanently delete Ad Lists' },
	{ scope: 'trademark:read', label: 'Search trademarks and read your trademark lists' },
	{ scope: 'trademark:write', label: 'Add, update and remove trademark list entries' },
	{ scope: 'upload:write', label: 'Import and edit designs, listings, tags, history and settings' },
	{ scope: 'upload:delete', label: 'Permanently delete designs or clear listing and history data' },
	{ scope: 'research:share', label: 'Send research image links by email' },
	{ scope: 'research:niche-analysis', label: 'Analyze niches and keywords' },
	{ scope: 'research:read', label: 'Read and compare research products, hobby ideas, social media holidays and POD Report links' },
	{ scope: 'upload:read', label: 'Read your upload library' },
	{ scope: 'research:favorites:write', label: 'Add products to your saved favorites' },
	{ scope: 'research:favorites:manage', label: 'Edit and remove saved favorites' },
	{ scope: 'research:board:write', label: 'Read and update your research board' },
	{ scope: 'research:watch:write', label: 'Compare and save seller brand watch snapshots' },
	{ scope: 'research:live', label: 'Start, monitor and stop live research' },
	{ scope: 'files:export', label: 'Export research and original design files (also select the relevant read permission)' }
];

export const MCP_PERMISSION_LABELS: Record<string, string> = Object.fromEntries(
	MCP_PERMISSION_OPTIONS.map((option) => [option.scope, option.label])
);
